<main [class.no-layout]="!showLayout" [ngClass]="{ hidden: !showLayout }">
    <mat-toolbar role="banner" *ngIf="showLayout" class="nav-bar not-print container grid mat-elevation-z4" #muyticoToolbar
    id="muyticoToolbar" appNoCtxMenu>
    <mat-toolbar-row *ngIf="isGhost | async as ghost" class="safearea">
      <div class="w-100 container content-center">
        <div class=" container vertical-center content-left" [class.w-20]="!isSmallScreen" [class.w-50]="isSmallScreen">
          <button mat-icon-button aria-label="Toggle navigation menu" *ngIf="isSmallScreen" (click)="drawer.toggle()"
            class="hamburger-menu">
            <mat-icon>menu</mat-icon>
          </button>
          <div class="img-nav" title="home" role="link" [routerLink]="['/home']">
            <img src="assets/icons/muytico 2.svg" alt="Muy Tico" loading="lazy"
              class="pointer no-click" />
          </div>
        </div>
        <div class="w-60 vertical-center">
          <app-search class="w-100" [drawer]="drawer" [utilities]="utilities"
            *ngIf="!isSmallScreen"></app-search>
        </div>
        <div class="vertical-center content-right" [class.w-20]="!isSmallScreen" [class.w-50]="isSmallScreen">
          <app-switch></app-switch>

          <button role="link" mat-icon-button [routerLink]="['/profile/login']" aria-label="Go to login"
            *ngIf="ghost === '1'; else userCart">
            <mat-icon>person_outline</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar-row>

    <mat-toolbar-row *ngIf="isSmallScreen">
      <app-search class="w-100" [drawer]="drawer" [utilities]="utilities"></app-search>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-sidenav-container appNoCtxMenu class="top-padding">
    <mat-sidenav class="scroll-contain" #drawer [mode]="(mobileDevice | async) ? 'over' : 'over'" id="drawer"
      [fixedInViewport]="true">
      <mat-action-list tabindex="0" role="navigation" *ngIf="categories$ | async as categories">
        <div *ngFor="let category of categories">
          <div>
            <mat-list-item (click)="searchProductTag(category); closeDrawer()">
              <img class="icon" [src]="
                  category?.File?.Route_File ?? 'assets/fondos/img-category.svg'
                " [alt]="category?.Value || 'Categoría sin imagen'" />
              <h3 class="text-category" matLine>{{ category.Value }}</h3>
            </mat-list-item>
          </div>
        </div>
      </mat-action-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="layout-spacer"></div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-loading></app-loading>
    <router-outlet></router-outlet>
</main>

<ng-template #noItem>
  <button mat-icon-button aria-label="Go to shopping cart" (click)="noItemsInCart()">
    <mat-icon>shopping_cart</mat-icon>
  </button>
</ng-template>

<ng-template #userCart>
  <div class="profile-home">
    <button mat-icon-button (click)="openCart()" aria-label="Go to shopping cart" [matBadge]="quantity"
      matBadgePosition="below after" *ngIf="items | async as quantity; else noItem">
      <mat-icon [ngClass]="{ 'select-icon': showCart }">shopping_cart</mat-icon>
    </button>
    <button mat-icon-button [routerLink]="['/profile']" aria-label="Go to my profile">
      <mat-icon>person_outline</mat-icon>
    </button>
  </div>
</ng-template>

<app-mini-cart *ngIf="showCart" class="mini-cart" (closeCart)="close()"
  (navigateToCart)="navigateToCart()"></app-mini-cart>